/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Update a doctor's slug
 * @export
 * @interface UpdateDoctorSlug
 */
export interface UpdateDoctorSlug {
    /**
     * Slug of the doctor
     * @type {string}
     * @memberof UpdateDoctorSlug
     */
    value: string;
}

/**
 * Check if a given object implements the UpdateDoctorSlug interface.
 */
export function instanceOfUpdateDoctorSlug(value: object): value is UpdateDoctorSlug {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function UpdateDoctorSlugFromJSON(json: any): UpdateDoctorSlug {
    return UpdateDoctorSlugFromJSONTyped(json, false);
}

export function UpdateDoctorSlugFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDoctorSlug {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function UpdateDoctorSlugToJSON(json: any): UpdateDoctorSlug {
    return UpdateDoctorSlugToJSONTyped(json, false);
}

export function UpdateDoctorSlugToJSONTyped(value?: UpdateDoctorSlug | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
    };
}

